<template>
  <v-card flat>
    <v-bottom-nav :value="true" absolute color="white">
      <v-btn
        v-for="(item, item_index) in currentBottomBar"
        :key="item_index"
        flat
        color="teal"
        :value="item.value"
        @click="$emit(item.event)"
      >
        <span>{{ item.text }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/audit";

export default {
  props: {
    bottombar: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getDocumentOnlineState]),
    currentBottomBar() {
      if (this.bottombar.length) {
        return this.bottombar;
      } else {
        const btns = [
          { value: "recent", event: "goback", text: "Back", icon: "undo" }
        ];
        if (this.getDocumentOnlineState) {
          btns.push({
            value: "sync",
            event: "",
            text: this.getDocumentOnlineState,
            icon: this.documentOnlineStateIcon
          });
        }
        btns.push({
          value: "share",
          event: "share",
          text: "Share",
          icon: "share"
        });

        return btns;
      }
    },
    documentOnlineStateIcon() {
      if (this.getDocumentOnlineState === "sync") {
        return "done_all";
      } else if (
        this.getDocumentOnlineState === "unsync" ||
        this.getDocumentOnlineState === "unsaved"
      ) {
        return "done";
      } else {
        return "cached";
      }
    }
  }
};
</script>
